/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type MinervaReactionMutationVariables = Types.Exact<{
  input: Types.MinervaReactionInput
}>

export type MinervaReactionMutation = {
  __typename?: 'Mutation'
  minervaReaction: {
    __typename?: 'MinervaReactionResponse'
    contextId: string
    reaction: Types.MinervaReactionType
  }
}

export const MinervaReactionDocument = gql`
    mutation minervaReaction($input: MinervaReactionInput!) {
  minervaReaction(input: $input) {
    contextId
    reaction
  }
}
    `
export type MinervaReactionMutationFn = Apollo.MutationFunction<
  MinervaReactionMutation,
  MinervaReactionMutationVariables
>

/**
 * __useMinervaReactionMutation__
 *
 * To run a mutation, you first call `useMinervaReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMinervaReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [minervaReactionMutation, { data, loading, error }] = useMinervaReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMinervaReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MinervaReactionMutation,
    MinervaReactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MinervaReactionMutation,
    MinervaReactionMutationVariables
  >(MinervaReactionDocument, options)
}
export type MinervaReactionMutationHookResult = ReturnType<
  typeof useMinervaReactionMutation
>
export type MinervaReactionMutationResult =
  Apollo.MutationResult<MinervaReactionMutation>
export type MinervaReactionMutationOptions = Apollo.BaseMutationOptions<
  MinervaReactionMutation,
  MinervaReactionMutationVariables
>
